import { AxiosInstance, AxiosRequestConfig } from 'axios'

import { ChatApiHospitalRepository } from './domain'

import {
  AutomatedMessage,
  AutomatedMessageReqParams,
  ChatSetting,
  ChatSettingCommand,
} from '../../contracts/hospital-chat'
import { AxiosErrorHandler, SolarResponse } from '../../foundation'

export class ChatApiHospital implements ChatApiHospitalRepository {
  private errorHandler: AxiosErrorHandler
  private hospitalId: number

  constructor(
    private axios: AxiosInstance,
    hospitalId: number,
  ) {
    this.hospitalId = hospitalId
    this.errorHandler = new AxiosErrorHandler()
  }

  getAutomatedMessage = async (params?: AutomatedMessageReqParams): Promise<AutomatedMessage[]> => {
    const config: AxiosRequestConfig = {
      url: `/partner/hospital/${this.hospitalId}/chat/automated-message`,
      method: 'get',
      ...(params && { params }),
    }

    try {
      const { data } = await this.axios.request<SolarResponse<AutomatedMessage[]>>(config)
      return data.data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  editAutomatedMessage = async (messageId: number, message: string): Promise<AutomatedMessage | undefined> => {
    const config: AxiosRequestConfig = {
      url: `/partner/hospital/${this.hospitalId}/chat/automated-message/${messageId}`,
      method: 'put',
      data: {
        message,
      },
    }

    try {
      const { data } = await this.axios.request<SolarResponse<AutomatedMessage>>(config)
      return data.data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }

  modifyChatSetting = async (command: ChatSettingCommand): Promise<SolarResponse<ChatSetting>> => {
    const config: AxiosRequestConfig = {
      url: `/partner/v3/hospitals/${this.hospitalId}`,
      method: 'put',
      data: command,
    }

    try {
      const { data } = await this.axios.request<SolarResponse<ChatSetting>>(config)
      return data
    } catch (error) {
      return this.errorHandler.handle(error)
    }
  }
}
